import { ReactNode } from 'react';
import { Button } from '@jobtarget/ui-library';
import OffCanvas from '../common/OffCanvas';

// Single-pane "Filter by Questions" drawer used when a job has 0 or 1
// questionnaire with completed responses. Mirrors the pre-VI-159 layout that
// shipped to UAT/Production. Per VI-485 leadership review (Ingrid Wang), the
// two-pane variant only activates when 2+ questionnaires have responses.
interface IQuestionCanvasSimple {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  hasSelectedQuestions?: boolean;
  onClearFilter?: () => void;
  position?: 'left' | 'right';
  title?: string;
}

const QuestionCanvasSimple = ({
  isOpen,
  onClose,
  children,
  position = 'right',
  title = 'Filter by Questions',
  onClearFilter,
  hasSelectedQuestions = false,
}: IQuestionCanvasSimple) => {
  const customFooter = (
    <div className="d-flex justify-content-between align-items-center w-100">
      <Button
        variant="transparent"
        onClick={() => {
          onClearFilter?.();
        }}
        disabled={!hasSelectedQuestions}
        style={{ color: '#2f86dd' }}
      >
        Clear Filter
      </Button>
    </div>
  );

  return (
    <OffCanvas
      isOpen={isOpen}
      onClose={onClose}
      position={position}
      title={title}
      width="50%"
      mobileWidth="100%"
      zIndex={1050}
      footerContent={customFooter}
    >
      {children}
    </OffCanvas>
  );
};

export default QuestionCanvasSimple;
